export default "__VITE_ASSET__CYTpFSfn__"